<template>
	<div class="block-form">
		<h1>Сканер</h1>
		<qrcode-scanner :scanFind="findCode" :mode="serverMode" @result="onScan" />
	</div>
	<hr>
	<div class="block-form">
		<ul class="code-list">
			<li v-for="item in code_list">{{ item.code }} {{ item.sended }}</li>
		</ul>
	</div>
</template>
	
<script>
import QrcodeScanner from '@/components/QrcodeScanner'
import router from '@/router'
import store from '@/store'
import axios from 'axios'

export default {
	name: 'ScanerView',
	components: {
		QrcodeScanner
	},
	data() {
		return {
			serverMode: null,
			findCode: null,

			// хранится uuid последнего прочитанного кода
			lastCode: '',
		}
	},
	mounted() {
		this.serverMode = this.$store.state.server_mode_select
	},
	watch: {
		lastCode(new_code, last_code) {
			if (store.state.scaned_code_list[last_code] && !store.state.scaned_code_list[last_code].sended) {
				// store.commit('addOrderForShipment', this.codeList[last_code])
				store.state.scaned_code_list[last_code].sending = false
				store.commit('addOrderForShipment', {
					code_uuid: last_code,
					code: store.state.scaned_code_list[last_code].code,
					session_id: store.getters.event_id,
					readed_ts: store.state.scaned_code_list[last_code].readed_ts
				})
			}
		}
	},
	computed: {
		code_list() {
			return this.$store.state.get_scaned_code
		}
	},
	methods: {
		// как отличить срочную отправку от
		// отложенной отправки из одного кода?
		async sendCode(uuid_code) {
			return new Promise((resolve, reject) => {
				axios({
					method: 'post',
					url: 'https://mobile-dev.expo-stat.ru/api/v2/qr_code',
					data: {
						uuid: store.getters.user_id,
						login: store.getters.user_name,
						point: store.getters.exhib_id,
						session: store.getters.event_id,
						data: [{
							code: store.state.scaned_code_list[uuid_code].code,
							readed_ts: store.state.scaned_code_list[uuid_code].readed_ts
						}]
					}
				}).then(response => {
					store.commit('update_server_info', {
						status: true,
						status_ts: Date.now()
					})
					resolve([response.data, uuid_code])
				}).catch(err => {
					store.commit('update_server_info', {
						status: false,
						status_ts: Date.now()
					})
					reject('Error...')
				})
			})
		},

		//update to scancollector
		async onScan(decodedText, decodedResult) {
			let uuid_decoded_text
			this.addNewCode(decodedText)
				.then((uuid) => {
					uuid_decoded_text = uuid
					this.lastCode = uuid_decoded_text // run watcher lastCode
					// this.updateLastCode(decodedText)
					// 24.09: обработать команды от сервера
					// ------ обновить время и статус доступности сервера
					return this.sendCode(uuid_decoded_text)
				})
				.then((data) => {
					const [respons, uuid_code] = data
					if (respons.result) {
						// this.lastCode = null
						store.commit('updateScanedCodeListItem', [uuid_decoded_text, {
							sended: true,
							sended_ts: Date.now(),
						}])
						this.findCode = true
					}
					// 24.09: обработать команды от сервера
					console.log('respons.command ->', respons.command)
					if (store.state.scaned_code_list[uuid_code].sending) {
						switch (respons.command) {
							case 'is_unlogined':
								// store.dispatch('serverUnlogin', null)
								store.commit('setUserAprove', false)
								store.commit('setExhib', { id: null, label: null })
								store.commit('setEvent', { id: null, label: null, start_ts: null, end_ts: null })
								router.push({ name: 'login' })
								break;
							case 'set_point':
								store.commit('setExhib', { id: null, label: null })
								router.push({ name: 'exhibSelector' })
								break;
							case 'set_session':
								router.push({ name: 'exhibSelector' })
								break;
							case 'clear_data':
								store.commit('setUserAprove', false)
								store.commit('setExhib', { id: null, label: null })
								store.commit('clearOrderForShipment')
								router.push({ name: 'login' })
								break;
							case 'debug_mode':
								console.log('debug a:->', store.getters.debug, respons.result)
								store.commit('switchDebugMode', respons.result)
								console.log('debug b:->', store.getters.debug)
								break;
						}
					}
				})
				.catch(() => {
					this.lastCodeToOrder(uuid_decoded_text)
				})
		},
		lastCodeToOrder(code_uuid) {
			store.commit('addOrderForShipment', {
				code_uuid: code_uuid,
				code: store.state.scaned_code_list[code_uuid].code,
				session_id: store.state.scaned_code_list[code_uuid].session_id,
				readed_ts: store.state.scaned_code_list[code_uuid].readed_ts
			})
		},
		addNewCode(code) {
			return new Promise(async resolve => {
				const code_uuid = await store.dispatch('uuidv4')
				store.commit('addToScanedCodeList', [
					code_uuid,
					{
						code: code,
						session_id: store.getters.event_id,
						readed_ts: Date.now(),
						sending: true,
						sended: false,
						sended_ts: null
					}

				])
				resolve(code_uuid)
			})
		},
	},
}
</script>
	

<style scoped>
.code-list {
	list-style: none;
}

.code-list li {
	padding: .7rem 1rem 1rem;
	border-bottom: 1px solid #a0a0a0;
}
</style>